import { Controller } from 'stimulus'
import { whenMapsReady } from '../../src/javascripts/google_maps_utils'

const MAP_OPTIONS = {
  zoom: 14,
  streetViewControl: false,
  disableDefaultUI: true,
  mapTypeControlOptions: { mapTypeIds: ['roadmap', 'hybrid'] },
}

const CIRCLE_OPTIONS = {
  strokeColor: '#2BB096',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#2BB096',
  fillOpacity: 0.35,
  radius: 400,
}

export default class extends Controller {
  static targets = ['map', 'modal', 'modalTitle']

  connect() {
    this.abortController = new AbortController()
    const { signal } = this.abortController

    if (this.isDialogModal()) {
      this.modalTarget.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') whenMapsReady(() => this.renderMap(this.modalTarget))
        },
        { signal }
      )
      return
    }

    this.boundMapUpdate = (event) => this.renderCoordinates(event.detail.lat, event.detail.lng)
    window.addEventListener('booking-location-map:update', this.boundMapUpdate, { signal })

    whenMapsReady(() => this.renderFirstResult())
    window.tippy('[data-tippy-content]')
    window.dispatchEvent(new CustomEvent('configureSelectedItems'))
  }

  disconnect() {
    this.abortController?.abort()
  }

  isDialogModal() {
    return this.hasModalTarget && this.modalTarget.tagName === 'DIALOG'
  }

  renderFirstResult() {
    const initial = this.element.querySelector('[data-region-map-initial]')
    const previewButton = initial || this.element.querySelector('.preview')
    if (previewButton) this.renderMap(previewButton)
  }

  renderMap(elem) {
    whenMapsReady(() => {
      if (!this.hasMapTarget) return

      const [lat, lng] = $(elem).data('primary-hotspot')
      this.renderCoordinates(lat, lng)
    })
  }

  renderCoordinates(lat, lng) {
    whenMapsReady(() => {
      if (!this.hasMapTarget || lat == null || lng == null) return

      const center = { lat, lng }

      if (!this.map) {
        this.map = new google.maps.Map(this.mapTarget, { ...MAP_OPTIONS, center })
        this.circle = new google.maps.Circle({ ...CIRCLE_OPTIONS, map: this.map, center })
        return
      }

      this.map.setCenter(center)
      this.circle.setCenter(center)
    })
  }

  openModal(event) {
    event.preventDefault()
    const elem = event.currentTarget
    this.renderMap(elem)

    if (elem.dataset.modalise) {
      if (this.hasModalTitleTarget) {
        this.modalTitleTarget.innerHTML = elem.dataset.regionName
      }
      this.modalTarget.classList.add('active')
      $('body').addClass('modal-shown')
    }

    return false
  }

  closeModal(event) {
    event.preventDefault()

    if (this.modalTarget.classList.contains('active')) {
      this.modalTarget.classList.remove('active')
      $('body').removeClass('modal-shown')
    }
  }
}
